module.exports = __webpack_public_path__ + "static/media/blueenergy-logo-web.99b9c443.png";